var _g, _path, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 62,
    viewBox: "0 0 266 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13354_6923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8514 19.3767H31.126C24.706 19.3704 19.4965 24.5697 19.49 30.9897C19.4881 32.9837 19.9991 34.9448 20.974 36.6842L6.61133 12.0403C17.0725 -1.49919 36.529 -3.99457 50.0685 6.46661C54.4166 9.8262 57.7931 14.2819 59.8514 19.3767Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1254 31.0014C62.1111 48.1156 48.2409 61.9858 31.1268 62C29.8306 62.0049 28.5359 61.9186 27.252 61.7418L41.2013 36.8137C44.3984 31.248 42.4926 24.1448 36.939 20.9269C35.1807 19.9089 33.1843 19.3741 31.1526 19.377H59.8521C61.3606 23.0665 62.1329 27.0155 62.1254 31.0014Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2006 36.8131L27.2512 61.7412H27.2254C10.2503 59.5965 -1.77205 44.0967 0.372663 27.1216C1.06686 21.6272 3.22114 16.4193 6.61138 12.04L20.974 36.6839L21.0515 36.8131C24.2544 42.3771 31.3613 44.2912 36.9253 41.0884C38.7027 40.0653 40.1777 38.5903 41.2006 36.8131Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2009 36.8138C37.998 42.3778 30.8911 44.2919 25.327 41.0891C23.5498 40.066 22.0749 38.591 21.0518 36.8138L20.9743 36.6846C17.8356 31.0841 19.8313 23.9996 25.4318 20.8609C27.1713 19.886 29.1324 19.375 31.1263 19.377H31.1521C33.1839 19.3741 35.1802 19.9089 36.9386 20.9269C42.4923 24.1449 44.398 31.2481 41.2009 36.8138Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2009 36.8138C37.998 42.3778 30.8911 44.2919 25.327 41.0891C23.5498 40.066 22.0749 38.591 21.0518 36.8138L20.9743 36.6846C17.8356 31.0841 19.8313 23.9996 25.4318 20.8609C27.1713 19.886 29.1324 19.375 31.1263 19.377H31.1521C33.1839 19.3741 35.1802 19.9089 36.9386 20.9269C42.4923 24.1449 44.398 31.2481 41.2009 36.8138Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0829 43.9171C28.8309 43.9169 26.6187 43.3234 24.6688 42.1967C22.7027 41.0595 21.0698 39.4258 19.9337 37.4591C16.3671 31.2814 18.4837 23.3821 24.6614 19.8154C26.627 18.6806 28.8571 18.0838 31.1269 18.085C38.2602 18.0794 44.0475 23.8577 44.053 30.991C44.0548 33.2617 43.4578 35.4926 42.3225 37.4591C39.9947 41.4611 35.7126 43.9215 31.0829 43.9171ZM31.15 20.6681C27.4432 20.6484 24.0113 22.6213 22.163 25.8346C19.3097 30.7823 21.0074 37.1064 25.9551 39.9597C30.9028 42.813 37.2268 41.1152 40.0802 36.1676C42.9335 31.2255 41.2402 24.906 36.2981 22.0525C34.7334 21.1492 32.9592 20.6719 31.1526 20.6683L31.15 20.6681Z",
    fill: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.138 61.2028C148.205 59.3367 155.067 54.321 159.358 47.5209C159.882 46.6911 158.958 45.6988 158.094 46.1627C154.795 47.9325 150.879 48.9579 146.679 48.9579C135.038 48.9579 125.578 41.0835 125.383 31.3075C125.317 28.0041 127.289 25.0835 130.15 23.8627L130.148 23.8613C128.457 24.4534 126.555 24.6981 125.084 25.7178C119.505 29.5851 116.118 36.7407 116.658 43.1737C117.181 49.4161 120.999 56.7311 127.601 59.9992C131.054 61.7082 135.509 61.4301 140.138 61.2028Z",
    fill: "url(#paint0_linear_13354_6923)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.858 40.3744C141.949 41.1376 144.256 41.5605 146.68 41.5605C156.178 41.5605 163.877 35.0685 163.877 27.0602C163.877 11.1837 149.07 0.143339 133.413 0.00129554C116.343 -0.153826 102.282 13.6409 102.127 30.711C102.127 30.711 106.398 17.5215 121.653 17.5215C131.976 17.5215 139.193 23.649 140.379 28.2809C140.696 29.127 140.871 30.043 140.871 30.9998C140.871 33.0064 140.107 34.8346 138.856 36.2104C137.615 37.5734 138.126 39.7427 139.858 40.3744Z",
    fill: "url(#paint1_linear_13354_6923)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.378 28.2807C139.193 23.6487 135.245 14.7227 122.421 14.7227C102.702 14.7227 102.126 30.7108 102.126 30.7108C101.969 47.9641 115.908 61.9996 133.125 61.9996C135.537 61.9996 137.884 61.724 140.137 61.2029C115.13 62.4309 112.561 30.0174 130.148 23.8615L130.15 23.8628C131.039 23.4833 132.014 23.2662 133.041 23.2552C136.398 23.2194 139.268 25.3199 140.378 28.2807Z",
    fill: "url(#paint2_linear_13354_6923)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13354_6923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.716 20.7947C261.41 17.6542 258.766 14.2637 256.689 13.1922C258.379 16.5052 259.357 19.8287 259.731 22.309C259.731 22.3139 259.733 22.326 259.737 22.359C256.34 13.8926 250.58 10.4787 245.877 3.04521C245.64 2.66935 245.401 2.29251 245.169 1.89521C245.051 1.69238 244.941 1.48507 244.839 1.27377C244.643 0.896447 244.493 0.497693 244.39 0.0854983C244.391 0.0450538 244.361 0.0101795 244.321 0.00497258C244.303 -0.000355443 244.283 -0.000355443 244.265 0.00497258C244.261 0.00642567 244.254 0.0113904 244.25 0.0130857C244.243 0.0157497 244.198 0.042632 244.2 0.0402102C236.654 4.45968 234.134 12.6034 233.899 16.6938C230.886 16.901 228.004 18.0111 225.631 19.8797C225.383 19.6698 225.123 19.4737 224.853 19.2922C224.169 16.8967 224.139 14.3613 224.769 11.9508C221.683 13.3559 219.283 15.577 217.538 17.5382H217.524C216.333 16.0298 216.417 11.0542 216.485 10.0154C216.471 9.95093 215.597 10.4691 215.482 10.5472C214.431 11.2972 213.449 12.1388 212.546 13.0621C211.519 14.1035 210.581 15.2288 209.741 16.4262C209.741 16.4276 209.74 16.4294 209.74 16.4309C209.74 16.4293 209.741 16.4276 209.741 16.4262C207.809 19.1636 206.439 22.2566 205.71 25.5267C205.696 25.5918 205.684 25.6593 205.67 25.7249C205.613 25.9894 205.41 27.3124 205.374 27.5999C205.371 27.622 205.37 27.6432 205.368 27.6654C205.104 29.0332 204.942 30.4184 204.88 31.81C204.88 31.8612 204.877 31.9119 204.877 31.9634C204.878 48.5523 218.327 61.9999 234.918 61.9999C249.776 61.9999 262.112 51.214 264.527 37.0466C264.578 36.6621 264.619 36.2756 264.664 35.8877C265.261 30.7365 264.598 25.3223 262.716 20.7947ZM228.092 44.306C228.232 44.3731 228.364 44.4465 228.509 44.5109C228.515 44.515 228.523 44.5196 228.529 44.5234C228.382 44.4533 228.236 44.3807 228.092 44.306ZM259.739 22.3664L259.735 22.3372C259.737 22.3479 259.739 22.359 259.74 22.3696L259.739 22.3664Z",
    fill: "url(#paint3_linear_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.715 20.7949C261.41 17.6544 258.765 14.2639 256.689 13.1924C258.379 16.5054 259.357 19.8289 259.731 22.3092C259.731 22.302 259.732 22.3153 259.735 22.3374C259.737 22.3481 259.738 22.3592 259.74 22.3698C262.574 30.0534 261.03 37.8668 258.805 42.6413C255.363 50.0287 247.029 57.5999 233.984 57.2305C219.89 56.8315 207.473 46.3738 205.155 32.6768C204.733 30.5169 205.155 29.4202 205.368 27.6664C205.109 29.0184 205.01 29.4089 204.88 31.811C204.88 31.8623 204.877 31.913 204.877 31.9645C204.877 48.5525 218.327 62.0001 234.917 62.0001C249.775 62.0001 262.112 51.2142 264.527 37.0468C264.578 36.6623 264.619 36.2758 264.664 35.8879C265.261 30.7367 264.597 25.3225 262.715 20.7949Z",
    fill: "url(#paint4_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.715 20.7949C261.41 17.6544 258.765 14.2639 256.689 13.1924C258.379 16.5054 259.357 19.8289 259.731 22.3092C259.731 22.302 259.732 22.3153 259.735 22.3374C259.737 22.3481 259.738 22.3592 259.74 22.3698C262.574 30.0534 261.03 37.8668 258.805 42.6413C255.363 50.0287 247.029 57.5999 233.984 57.2305C219.89 56.8315 207.473 46.3738 205.155 32.6768C204.733 30.5169 205.155 29.4202 205.368 27.6664C205.109 29.0184 205.01 29.4089 204.88 31.811C204.88 31.8623 204.877 31.913 204.877 31.9645C204.877 48.5525 218.327 62.0001 234.917 62.0001C249.775 62.0001 262.112 51.2142 264.527 37.0468C264.578 36.6623 264.619 36.2758 264.664 35.8879C265.261 30.7367 264.597 25.3225 262.715 20.7949Z",
    fill: "url(#paint5_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.118 24.3261C248.183 24.3721 248.243 24.4179 248.305 24.4635C247.551 23.1255 246.612 21.9005 245.516 20.8246C236.178 11.4879 244.206 0.0395312 244.209 0.0371094C236.662 4.45658 234.136 12.6037 233.9 16.694C234.25 16.6697 234.599 16.6403 234.956 16.6403C240.587 16.6404 245.491 19.7366 248.118 24.3261Z",
    fill: "url(#paint6_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.973 26.1898C234.924 26.937 232.284 29.5138 231.361 29.5138C222.818 29.5138 221.432 34.6807 221.432 34.6807C221.81 39.0319 224.839 42.615 228.508 44.5109C228.675 44.5973 228.845 44.6755 229.014 44.7527C229.305 44.8814 229.599 45.0017 229.897 45.1134C231.154 45.5588 232.472 45.8129 233.805 45.8674C248.778 46.5696 251.678 27.9684 240.873 22.5667C243.64 22.0855 246.513 23.1983 248.117 24.3251C245.49 19.736 240.585 16.6396 234.954 16.6396C234.598 16.6396 234.249 16.6691 233.899 16.6933C230.886 16.9005 228.005 18.0106 225.631 19.8792C226.089 20.2667 226.606 20.7847 227.696 21.8577C229.733 23.866 234.962 25.9458 234.973 26.1898Z",
    fill: "url(#paint7_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.973 26.1898C234.924 26.937 232.284 29.5138 231.361 29.5138C222.818 29.5138 221.432 34.6807 221.432 34.6807C221.81 39.0319 224.839 42.615 228.508 44.5109C228.675 44.5973 228.845 44.6755 229.014 44.7527C229.305 44.8814 229.599 45.0017 229.897 45.1134C231.154 45.5588 232.472 45.8129 233.805 45.8674C248.778 46.5696 251.678 27.9684 240.873 22.5667C243.64 22.0855 246.513 23.1983 248.117 24.3251C245.49 19.736 240.585 16.6396 234.954 16.6396C234.598 16.6396 234.249 16.6691 233.899 16.6933C230.886 16.9005 228.005 18.0106 225.631 19.8792C226.089 20.2667 226.606 20.7847 227.696 21.8577C229.733 23.866 234.962 25.9458 234.973 26.1898Z",
    fill: "url(#paint8_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.232 18.8801C224.441 19.0152 224.649 19.1526 224.854 19.2926C224.17 16.8971 224.141 14.3617 224.77 11.9512C221.684 13.3563 219.284 15.5774 217.539 17.5386C217.683 17.5346 222.041 17.4561 224.232 18.8801Z",
    fill: "url(#paint9_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.156 32.6769C207.473 46.374 219.89 56.8316 233.984 57.2308C247.029 57.6 255.363 50.0284 258.806 42.6415C261.031 37.8667 262.575 30.0542 259.74 22.37L259.74 22.3667L259.736 22.3377C259.732 22.3154 259.731 22.3022 259.731 22.3095C259.731 22.3143 259.733 22.3264 259.737 22.3595C260.802 29.317 257.263 36.0572 251.731 40.6147L251.714 40.6538C240.934 49.4315 230.618 45.9498 228.529 44.5245C228.382 44.4539 228.236 44.3813 228.092 44.3067C221.806 41.3031 219.21 35.5771 219.767 30.6665C214.46 30.6665 212.65 26.1904 212.65 26.1904C212.65 26.1904 217.415 22.7931 223.695 25.7479C229.511 28.4844 234.973 26.1907 234.974 26.1904C234.962 25.9464 229.734 23.8667 227.696 21.8585C226.607 20.7855 226.09 20.2682 225.632 19.88C225.383 19.6702 225.123 19.474 224.853 19.2925C224.647 19.1527 224.44 19.0153 224.231 18.88C222.04 17.456 217.682 17.5345 217.538 17.5382H217.524C216.333 16.0299 216.417 11.0543 216.485 10.0153C216.471 9.95087 215.597 10.469 215.482 10.5471C214.431 11.2972 213.449 12.1389 212.547 13.0621C211.52 14.1037 210.581 15.2292 209.741 16.4268C209.741 16.4283 209.741 16.4301 209.74 16.4316C209.74 16.43 209.741 16.4283 209.741 16.4268C207.81 19.1642 206.44 22.2573 205.711 25.5273C205.696 25.5922 204.629 30.2573 205.156 32.6769Z",
    fill: "url(#paint10_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.516 20.8243C246.612 21.9002 247.551 23.1251 248.304 24.4632C248.47 24.5874 248.624 24.7113 248.755 24.8322C255.566 31.107 251.997 39.9819 251.731 40.6144C257.264 36.057 260.803 29.3167 259.737 22.3591C256.341 13.8928 250.581 10.4788 245.878 3.04541C245.64 2.66954 245.402 2.29271 245.17 1.89541C245.052 1.69258 244.941 1.48527 244.839 1.27397C244.644 0.896646 244.493 0.497892 244.39 0.0856967C244.392 0.0452521 244.362 0.0103778 244.322 0.0051709C244.303 -0.000157117 244.293 -0.00221567 244.274 0.00311235C244.27 0.00456545 244.255 0.0115887 244.25 0.013284C244.244 0.015948 244.235 0.0221237 244.228 0.0257564C243.084 0.614503 236.178 11.4875 245.516 20.8243Z",
    fill: "url(#paint11_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.754 24.832C248.623 24.7112 248.468 24.5873 248.303 24.4631C248.242 24.417 248.182 24.3713 248.117 24.3256C246.513 23.1989 243.64 22.086 240.873 22.5673C251.678 27.9689 248.778 46.5701 233.805 45.8679C232.472 45.8135 231.154 45.5594 229.896 45.114C229.599 45.0021 229.305 44.8819 229.014 44.7533C228.845 44.676 228.675 44.5979 228.508 44.5114C228.514 44.5156 228.522 44.5202 228.528 44.5239C230.617 45.9489 240.933 49.4309 251.713 40.6532L251.73 40.6141C251.996 39.9823 255.564 31.1071 248.754 24.832Z",
    fill: "url(#paint12_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.433 34.6811C221.433 34.6811 222.819 29.5143 231.362 29.5143C232.285 29.5143 234.925 26.9374 234.974 26.1902C235.023 25.4429 229.512 28.4841 223.695 25.7476C217.415 22.7928 212.65 26.1902 212.65 26.1902C212.65 26.1902 214.46 30.6662 219.767 30.6662C219.21 35.5768 221.807 41.3035 228.092 44.3064C228.232 44.3735 228.364 44.4469 228.509 44.5113C224.84 42.6154 221.811 39.0323 221.433 34.6811Z",
    fill: "url(#paint13_radial_13354_6923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.715 20.7949C261.409 17.6544 258.765 14.2639 256.689 13.1924C258.379 16.5054 259.357 19.8289 259.73 22.3092C259.73 22.3141 259.732 22.3262 259.736 22.3592C256.339 13.8928 250.58 10.4788 245.876 3.04541C245.639 2.66954 245.401 2.29271 245.169 1.89541C245.051 1.69258 244.94 1.48527 244.838 1.27397C244.643 0.896646 244.492 0.497892 244.389 0.0856967C244.39 0.0452522 244.361 0.0103778 244.321 0.0051709C244.302 -0.000157117 244.291 -0.00221567 244.273 0.00311235C244.269 0.00456545 244.254 0.0115887 244.249 0.013284C244.243 0.015948 244.219 0.0296314 244.216 0.0313266C236.456 4.67639 234.134 12.6038 233.898 16.694C234.248 16.6698 234.597 16.6403 234.954 16.6403C240.585 16.6403 245.49 19.7365 248.116 24.3258C246.512 23.199 243.64 22.0862 240.873 22.5674C251.678 27.969 248.777 46.5703 233.805 45.868C232.471 45.8137 231.154 45.5595 229.896 45.1143C229.598 45.0024 229.304 44.8821 229.013 44.7535C228.844 44.6763 228.675 44.5982 228.507 44.5117C228.513 44.5158 228.521 44.5204 228.527 44.5242C228.381 44.4536 228.235 44.3809 228.09 44.3063C228.23 44.3734 228.362 44.4468 228.507 44.5112C224.838 42.6153 221.809 39.0322 221.431 34.681C221.431 34.681 222.817 29.5142 231.359 29.5142C232.283 29.5142 234.923 26.9373 234.972 26.1901C234.961 25.9461 229.732 23.8664 227.694 21.8582C226.605 20.7852 226.088 20.2679 225.63 19.8797C225.381 19.6698 225.122 19.4736 224.852 19.2921C224.167 16.8967 224.138 14.3613 224.767 11.9507C221.682 13.3559 219.281 15.5769 217.536 17.5381H217.522C216.332 16.0298 216.416 11.0542 216.483 10.0152C216.469 9.95077 215.595 10.4689 215.481 10.547C214.43 11.2971 213.447 12.1386 212.545 13.062C211.518 14.1036 210.58 15.2289 209.74 16.4264C209.74 16.4278 209.74 16.4296 209.739 16.4311C209.739 16.4295 209.74 16.4278 209.74 16.4264C207.809 19.1638 206.439 22.2568 205.71 25.5269C205.695 25.592 205.683 25.6595 205.669 25.7251C205.613 25.9896 205.359 27.3317 205.323 27.6196C205.32 27.6417 205.326 27.5975 205.323 27.6196C205.091 29.0064 204.943 30.406 204.88 31.8108C204.88 31.862 204.877 31.9128 204.877 31.9642C204.877 48.5524 218.327 62 234.917 62C249.775 62 262.112 51.2141 264.527 37.0467C264.578 36.6622 264.618 36.2757 264.663 35.8878C265.26 30.7367 264.597 25.3225 262.715 20.7949ZM259.735 22.3375C259.736 22.3481 259.738 22.3592 259.74 22.3698L259.739 22.3665L259.735 22.3375Z",
    fill: "url(#paint14_linear_13354_6923)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13354_6923",
    x1: 116.602,
    y1: 42.6171,
    x2: 159.511,
    y2: 42.6171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00376F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13354_6923",
    x1: 114.804,
    y1: 10.9325,
    x2: 150.702,
    y2: 32.1681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13354_6923",
    x1: 118.166,
    y1: 17.1654,
    x2: 127.835,
    y2: 61.5327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0016,
    stopColor: "#006393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0086DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13354_6923",
    x1: 257.21,
    y1: 9.59121,
    x2: 208.975,
    y2: 56.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.507 13.1956) scale(61.4395 62.4741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF027B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF0083"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.274 32.7378) scale(62.9755 62.4741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#AF0611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CE1223",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FD243B",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF304B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3450",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.814 -2.89279) scale(20.165 34.2352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.503 48.8508) scale(26.6859 29.2481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#008EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF36EA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.92 26.2865) scale(14.1689 17.2548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#80008E",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.902 4.6089) scale(21.2149 21.2903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(252.27 -9.35295) scale(101.285 85.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(243.706 -7.69043) rotate(83.9544) scale(66.5863 67.0847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.117 12.2671) scale(58.151 57.1295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF0D8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_13354_6923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.213 15.6045) scale(69.8957 62.5301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13354_6923",
    x1: 254.252,
    y1: 9.94577,
    x2: 215.675,
    y2: 52.0961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF339",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF339",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13354_6923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(0.125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13354_6923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(203.877)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsers);
export default __webpack_public_path__ + "static/media/Browsers.ec1833ec906ea6ee5d7ce6faf5b361ba.svg";
export { ForwardRef as ReactComponent };